function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#clip0_14570_2286)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M2.74214 0.90625H0.720703V7.95603H2.71431C3.77969 7.95603 4.54493 7.70852 5.22868 7.13368C6.02175 6.47501 6.5127 5.46106 6.5127 4.41717C6.5127 2.35932 4.95637 0.90625 2.74214 0.90625ZM4.32828 6.20157C3.891 6.58479 3.34439 6.75046 2.44399 6.75046H2.0882V2.08587H2.44399C3.31855 2.08587 3.86516 2.24954 4.32828 2.66271C4.81923 3.10182 5.09352 3.76049 5.09352 4.41916C5.09153 5.10378 4.81923 5.7884 4.32828 6.20157Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.50614 0.90625H7.14062V7.95603H8.50614V0.90625Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8677 3.59473C11.0488 3.29334 10.8023 3.10172 10.8023 2.7165C10.8023 2.27739 11.2396 1.94805 11.8141 1.94805C12.2235 1.94805 12.5515 2.11172 12.9351 2.52489L13.6447 1.56483C13.0444 1.04388 12.3607 0.768433 11.5676 0.768433C10.3114 0.768433 9.38118 1.64666 9.38118 2.79834C9.38118 3.78634 9.81846 4.27935 11.1025 4.74641C11.6491 4.93802 11.9214 5.07574 12.0585 5.15758C12.3308 5.32125 12.468 5.59669 12.468 5.89808C12.468 6.47492 12.0029 6.88609 11.4026 6.88609C10.7467 6.88609 10.2279 6.55675 9.89995 5.95397L9.02539 6.77631C9.65349 7.70843 10.4187 8.1196 11.4563 8.1196C12.8774 8.1196 13.8872 7.15954 13.8872 5.7883C13.8892 4.69251 13.426 4.17157 11.8677 3.59473Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.3262 4.44496C14.3262 6.53075 15.9382 8.12154 18.0411 8.12154C18.6413 8.12154 19.1343 8.01177 19.7624 7.71037V6.09164C19.2158 6.64053 18.7248 6.86009 18.0967 6.86009C16.7034 6.86009 15.7473 5.84414 15.7473 4.41901C15.7473 3.07573 16.759 2.00389 18.0431 2.00389C18.699 2.00389 19.1899 2.22345 19.7644 2.80028V1.18155C19.1641 0.880156 18.6712 0.742433 18.0709 0.742433C15.9938 0.740437 14.3262 2.38711 14.3262 4.44496Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M30.8552 5.65267L28.9968 0.90625H27.4941L30.4716 8.14964H31.211L34.2422 0.90625H32.7674L30.8552 5.65267Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.8711 7.95603H38.751V6.77641H36.2386V4.85628H38.6695V3.64872H36.2386V2.08587H38.751V0.90625H34.8711V7.95603Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.1862 2.98997C44.1862 1.67262 43.2838 0.904175 41.6996 0.904175H39.6523V7.95395H41.0179V5.13165H41.2087L43.093 7.95794H44.7864L42.5742 4.99392C43.6137 4.77437 44.1862 4.0618 44.1862 2.98997ZM41.4273 4.14364H41.0179V2.00396H41.4273C42.274 2.00396 42.7392 2.36124 42.7392 3.04585C42.767 3.75842 42.3019 4.14364 41.4273 4.14364Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.0782 8.20228C26.1299 8.20228 27.7931 6.53209 27.7931 4.47181C27.7931 2.41152 26.1299 0.741333 24.0782 0.741333C22.0265 0.741333 20.3633 2.41152 20.3633 4.47181C20.3633 6.53209 22.0265 8.20228 24.0782 8.20228Z",
  fill: "url(#paint0_linear_14570_2286)"
}), /*#__PURE__*/React.createElement("path", {
  opacity: 0.65,
  d: "M24.0782 8.20427C26.1294 8.20427 27.7931 6.53365 27.7931 4.4738C27.7931 2.41396 26.1314 0.741333 24.0782 0.741333C22.025 0.741333 20.3633 2.41196 20.3633 4.47181C20.3633 6.53165 22.0269 8.20427 24.0782 8.20427Z",
  fill: "url(#paint1_radial_14570_2286)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45.1467 1.20846C45.1467 1.07074 45.0653 1.01685 44.9003 1.01685H44.6816V1.67552H44.8446V1.40007L45.0354 1.64757H45.2263L45.0076 1.37412C45.0931 1.37213 45.1467 1.29029 45.1467 1.20846ZM44.8744 1.29029L44.8466 1.12662H44.8744C44.9559 1.12662 44.9838 1.15457 44.9838 1.20846C44.9838 1.26235 44.9281 1.29029 44.8744 1.29029Z",
  fill: "black"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44.9279 0.741333C44.6 0.741333 44.3535 0.988834 44.3535 1.31817C44.3535 1.6475 44.6 1.89501 44.9279 1.89501C45.2281 1.89501 45.5024 1.6475 45.5024 1.31817C45.4745 1.01478 45.2281 0.741333 44.9279 0.741333ZM44.9279 1.78323C44.6815 1.78323 44.4628 1.56367 44.4628 1.31617C44.4628 1.04272 44.6536 0.849116 44.9279 0.849116C45.1744 0.849116 45.3652 1.06867 45.3652 1.31617C45.3652 1.59162 45.1744 1.78323 44.9279 1.78323Z",
  fill: "black"
}));
var _ref3 =
/*#__PURE__*/
/*#__PURE__*/
React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_14570_2286",
  x1: 25.9804,
  y1: 7.46263,
  x2: 23.3928,
  y2: 3.42802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9A020"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.2041,
  stopColor: "#F99D20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.4348,
  stopColor: "#F79320"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.6196,
  stopColor: "#F68820"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.7969,
  stopColor: "#F57E20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F47521"
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "paint1_radial_14570_2286",
  cx: 0,
  cy: 0,
  r: 1,
  gradientUnits: "userSpaceOnUse",
  gradientTransform: "translate(25.5585 7.17905) rotate(-117.709) scale(6.5636 5.07888)"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FF932C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.5677,
  stopColor: "#E86D20"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.8604,
  stopColor: "#E85718",
  stopOpacity: 0.8653
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#640000"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_14570_2286"
}, /*#__PURE__*/React.createElement("rect", {
  width: 44.7776,
  height: 7.46294,
  fill: "white",
  transform: "translate(0.720703 0.740723)"
})));
const SvgDiscover = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 19,
    viewBox: "0 0 46 9",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscover, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/discover.6d3669e4.svg";
export { ForwardRef as ReactComponent };